import styled, { keyframes } from 'styled-components';

export const rotation = keyframes`
  0% {
    transform: rotate(0);
  } 
  100% {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
  position: relative;
  height: ${({ height }) => `${height}px;`};
  display: block;
  z-index: 3;
  
  i {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 60px;
    height: 60px;
    font-size: 60px;
    animation: ${rotation} 2s linear infinite;
    
    &:before {
      display: block;
      margin-left: 0;
      margin-right: 0;
    }
  }
`;
